import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const TOKEN_KEY = 'admin_jwt_token';

export default function MaintenancePage() {
  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Helper to get token
  const getToken = () => localStorage.getItem(TOKEN_KEY);

  // Helper to add Authorization header
  const authFetch = (url, options = {}) => {
  const apiPrefix = window.location.pathname.match(/^\/[^\/]+/) ? window.location.pathname.match(/^\/[^\/]+/)[0].replace(/\/$/, '') : '';
    const token = getToken();
    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    setError('');
    authFetch('/api/maintenance')
      .then(res => res.json())
      .then(data => {
        setEnabled(!!data.enabled);
        setMessage(data.message || '');
      })
      .catch(() => setError('Failed to fetch maintenance status.'))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await authFetch('/api/maintenance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled, message })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess('Maintenance mode updated successfully.');
      } else {
        setError(data.error || 'Failed to update maintenance mode.');
      }
    } catch {
      setError('Failed to update maintenance mode.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Maintenance Mode</h2>
      <form onSubmit={handleSave} className="mt-3">
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="maintenanceEnabled"
            checked={enabled}
            onChange={e => setEnabled(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="maintenanceEnabled">
            Enable Maintenance Mode
          </label>
        </div>
        <div className="mb-3">
          <label htmlFor="maintenanceMessage" className="form-label">Maintenance Message</label>
          <textarea
            className="form-control"
            id="maintenanceMessage"
            rows={3}
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Enter a custom maintenance message..."
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </button>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
        {success && <div className="alert alert-success mt-3">{success}</div>}
      </form>
    </div>
  );
}
